import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { SharedButton } from "@components";
import { selectAuth, selectMerchant } from "@redux";
import { useEffect, useState } from "react";
import { IConClose } from "./icon";

interface IProps {
    handleToggleQrCode: () => void;
}

export const ComponentQRcode = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //redux states
    const [sellerId, setSellerId] = useState<string>("");
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    //props
    const { handleToggleQrCode } = props;

    useEffect(() => {
        if (userInfo?.contact?.sellerId) {
            setSellerId(userInfo?.contact?.sellerId);
        }
    }, [userInfo]);

    // const fetchInfo = async () => {
    //     const info = await authApi.getInfo();
    //     setUserInfo(info?.data);
    //     if (info?.data?.contact?.sellerId) {
    //         setSellerId(info?.data?.contact?.sellerId);
    //     }
    // };

    return (
        <div className="righttoleft">
            <StyledContainer>
                <div className="room" onClick={handleToggleQrCode}>
                    <IConClose width={18} color="black" />
                </div>
                <div className="content">
                    <div className="my_qrCode text-sub-header">
                        <span className="english">{t("page.my_qr_title")}</span>
                    </div>
                    {(userInfo?.memberCode !== undefined || sellerId !== "") && (
                        <QRCode
                            value={sellerId === "" ? userInfo?.memberCode || "" : sellerId}
                            size={200}
                        />
                    )}

                    <div className="merchant_id">
                        <p className="title text-body">
                            {sellerId === "" ? t("page.member_id") : t("page.seller_id")}
                        </p>
                        <p className="code text-sub-header eng-number">
                            {sellerId === "" ? userInfo?.memberCode : sellerId}
                        </p>
                    </div>
                    <StyledButton
                        size="large"
                        bg_color={themes?.themeColor!}
                        type="submit"
                        className="btn-text"
                        onClick={handleToggleQrCode}
                    >
                        {t("page.done")}
                    </StyledButton>
                </div>
            </StyledContainer>
        </div>
    );
};

const StyledContainer = styled.div`
    width: calc(100% - 30px);
    margin: 0 auto;
    top: 103px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background-color: ${(p) => p.theme.colors.background};
    padding: 70px 0;
    border-radius: 16px;
    z-index: 100;
    .content {
        width: 70%;
        margin: 0 auto;
        text-align: center;
    }
    .room {
        position: absolute;
        top: 24px;
        right: 48px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .my_qrCode {
        line-height: 1.5rem;
        text-align: center;
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 36px;
        .english {
            margin-right: 10px;
        }
        .thai {
        }
    }
    .merchant_id {
        margin-top: 36px;
        padding: 16px 24px;
        p {
            margin: initial;
        }
        .title {
            color: inherit;
        }
        .code {
            color: ${(p) => p.theme.colors.color};
            margin-top: 4px;
            word-break: break-word;
            line-height: 1.5rem;
        }
    }
`;

const StyledButton = styled(SharedButton)`
    margin-top: 12px;
    width: auto;
    padding: 10px 37px;
    border-radius: 26px;
    height: 55px;
`;
